import { EntityListSourceType } from '@ydistri/api-sdk';
import React, { CSSProperties, useCallback } from 'react';
import { Column, IconButton_IconSizes, Row, Text } from '@ydistri/ds';
import { HiOutlineUser } from 'react-icons/hi';
import { MdOutlineSettingsInputHdmi } from 'react-icons/md';
import { PiVinylRecordFill } from 'react-icons/pi';
import { Popover } from 'antd';
import { COLORS } from '@ydistri/theme';
import { SYSTEM_ID_LABEL } from '../../global/_constants';
import { IconType } from 'react-icons';
import { ClipboardTextWithToast } from '../../global/ClipboardTextWithToast/ClipboardTextWithToast';

interface EntityListVersionDataProps {
  entityListId?: number;
  entityListVersionId?: number;
  customerEntityListId?: string | null;
}

interface EntityListSourceTypeIconProps extends EntityListVersionDataProps {
  entityListSourceType: EntityListSourceType;
  size?: CSSProperties['width'];
}

/**
 * Internal component to display entity list Ids
 */
const EntityListVersionData: React.FC<EntityListVersionDataProps> = ({
  entityListId,
  customerEntityListId,
  entityListVersionId,
}) => {
  if (!(entityListId || entityListVersionId || customerEntityListId)) return null;

  return (
    <Row $gap="1rem">
      {customerEntityListId && (
        <ClipboardTextWithToast
          text={`Id: ${customerEntityListId}`}
          textToCopy={customerEntityListId}
        />
      )}
      {entityListId && (
        <ClipboardTextWithToast
          text={`${SYSTEM_ID_LABEL}: ${entityListId}`}
          textToCopy={`${entityListId}`}
        />
      )}
      {entityListVersionId && (
        <ClipboardTextWithToast
          text={`Version Id: ${entityListVersionId}`}
          textToCopy={`${entityListVersionId}`}
        />
      )}
    </Row>
  );
};

const EntityListSourceTypeIcon: React.FC<EntityListSourceTypeIconProps> = ({
  entityListSourceType,
  entityListVersionId,
  entityListId,
  customerEntityListId,
  size = IconButton_IconSizes.normal,
}) => {
  const color = COLORS.GREY;

  // eslint-disable-next-line @typescript-eslint/naming-convention -- Icon is a component here
  let Icon: IconType;

  switch (entityListSourceType) {
    case EntityListSourceType.User:
      Icon = HiOutlineUser;
      break;
    case EntityListSourceType.Integration:
      Icon = MdOutlineSettingsInputHdmi;
      break;
    case EntityListSourceType.Computation:
      Icon = PiVinylRecordFill;
      break;
  }

  const createPopupContent = useCallback(() => {
    return (
      <Column>
        <Text>{entityListSourceType}</Text>
        <EntityListVersionData
          entityListId={entityListId}
          entityListVersionId={entityListVersionId}
          customerEntityListId={customerEntityListId}
        />
      </Column>
    );
  }, [customerEntityListId, entityListId, entityListSourceType, entityListVersionId]);

  return (
    <Popover content={createPopupContent} zIndex={9999}>
      <Icon size={size} color={color} />
    </Popover>
  );
};

export default EntityListSourceTypeIcon;
